import React from "react";
import useEngravingCertificate from "./useEngravingCertificate";
import {
  ModalLayout,
  Pagination,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import AddStatus from "../AddStatus";
import { ProfileCard } from "./ProfileCard";
import Style from "../engravingSection.module.scss";
import PassAll from "../../../Global/PassAll";
import RemarksTable from "../../../Global/RemarksTable";
import { SearchFilters } from "@wac-ui-dashboard/wac_component_library";
import { Table } from "../../../Global/Table";
const EngravingCertificate = ({
  gliNumber,
  // certificateList,
  // setCertificateList,
}) => {
  const {
    paginationOptions,
    disableMultiSelect,
    engravingSectionState,
    showImageModal,
    imageData,
    certificateList,
    isFetching,
    formik,
    globalRemarkModal,
    passAllModal,
    isLoading,
    handleSearch,
    handleDownload,
    closeModal,
    getRow,
    handleConfirm,
    handlePageSize,
    handlePassAll,
    handleModalClose,
    handlePassAllClick,
    handlePagination,
    handleConfirmModal,
    handleClearClick,
  } = useEngravingCertificate();

  return (
    <>
      <h5 className="pro-ttl h5 pro-mb-2">{gliNumber}</h5>
      <div className={Style.btns}>
        <SearchFilters
          onSearchInput={handleSearch}
          showActions={false}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters
          handleClear={handleClearClick}
          searchInputProps={{
            value: engravingSectionState?.certificate?.search,
          }}
        />
        <button
          className={`${Style.Print_btn} pro-btn pro-items-center pro-btn-outline`}
          onClick={handlePassAllClick}
        >
          <span className="material-symbols-outlined">check_circle</span>
          <span>All Engraved</span>
        </button>
      </div>
      <Table
        multiSelect={disableMultiSelect ? false : true}
        data={certificateList?.data?.data || []}
        uniqueID={"id"}
        fields={certificateList?.data?.fields || []}
        showCheckBox={true}
        SortIcon={<FaSort />}
        loading={isFetching}
        getRow={getRow}
        perpage={10}
        assignable={true}
        editable={false}
        deletable={false}
        assignText={"Submit"}
        assignIcon={
          <span className="material-symbols-outlined">check_circle</span>
        }
        handleAssign={handleConfirmModal}
        clear={engravingSectionState?.clear}
      />

      <ModalLayout show={showImageModal} handleClose={closeModal}>
        <ProfileCard
          data={imageData}
          handleClose={closeModal}
          handleDownload={handleDownload}
        />
      </ModalLayout>
      <ModalLayout
        show={engravingSectionState?.showAddEngravingSecModal}
        handleClose={handleConfirmModal}
        title={"Choose status of submission?"}
      >
        <div className="pro-m-5">
          <AddStatus
            handleConfirm={handleConfirm}
            handleConfirmModal={handleConfirmModal}
          />
        </div>
      </ModalLayout>
      <Pagination
        currentPage={engravingSectionState.certificate?.currentPage}
        totalPageCount={Math.ceil(
          certificateList?.data?.total_count / certificateList?.data?.per_page,
        )}
        onPageChange={handlePagination}
        options={paginationOptions}
        onActionChange={handlePageSize}
        center
      />
      <ModalLayout
        show={passAllModal}
        title={"Pass All"}
        handleClose={handlePassAllClick}
        closeIcon={<span className="material-symbols-outlined">close</span>}
      >
        <PassAll
          formik={formik}
          handleSubmit={handlePassAll}
          handleCancel={handlePassAllClick}
        />
      </ModalLayout>
      <ModalLayout
        show={globalRemarkModal}
        handleClose={handleModalClose}
        title={"Remarks"}
        propStyle={{ root: "pro-modal-xxl" }}
        closeIcon={<span className="material-symbols-outlined">close</span>}
      >
        <div className="pro-m-5">
          <RemarksTable />
        </div>
      </ModalLayout>
    </>
  );
};

export default EngravingCertificate;
